import * as i0 from '@angular/core';
import { Component, Inject, Input, NgModule } from '@angular/core';
import * as i1 from '@upr-web-primer/locale';
import { LocaleService } from '@upr-web-primer/locale';
import * as i2 from '@upr-web-primer/tcm-anchor';
import { TcmAnchorModule } from '@upr-web-primer/tcm-anchor';
import * as i3 from '@upr-web-primer/tcm-picture';
import { TcmPictureModule } from '@upr-web-primer/tcm-picture';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { LazyLoadModule } from '@upr-web-primer/lazy-load';

class NavHeaderLogoComponent {
    constructor(contentURL, localeService) {
        this.contentURL = contentURL;
        this.localeService = localeService;
    }
    ngOnInit() {
        const locale = this.localeService.getFromStorage();
        this.headerLogoURL = !!this.contentURL
            ? `${this.contentURL}/${locale.language}/${locale.country}/index.html`
            : `${locale.language}/${locale.country}`;
    }
}
NavHeaderLogoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavHeaderLogoComponent, deps: [{ token: 'WebContentUrl' }, { token: i1.LocaleService }], target: i0.ɵɵFactoryTarget.Component });
NavHeaderLogoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: NavHeaderLogoComponent, selector: "upr-nav-header-logo", inputs: { data: "data" }, ngImport: i0, template: "<ng-container *ngIf=\"data\">\r\n\t<tcm-anchor\r\n\t\t[overwriteUrl]=\"headerLogoURL\"\r\n\t\t[transclude]=\"true\"\r\n\t\t[anchorClass]=\"'header-logo'\"\r\n\t>\r\n\t\t<tcm-picture\r\n\t\t\t[overrideImage]=\"data?.Component?.Multimedia?.Url\"\r\n\t\t\t[overrideAltText]=\"(data?.Component?.MetadataFields?.alt?.Values)[0]\"\r\n\t\t\t[lazy]=\"false\"\r\n\t\t>\r\n\t\t</tcm-picture>\r\n\t</tcm-anchor>\r\n</ng-container>\r\n", styles: [""], components: [{ type: i2.TcmAnchorComponent, selector: "tcm-anchor", inputs: ["routerLinkExact", "analyticsTitle", "chevronClass", "embeddedValue", "useRouterLinkActive", "overwriteLinkText", "overwriteTarget", "overwriteQueryParams", "overwriteHash", "overwriteRole", "anchorClass", "anchorStyle", "transclude", "ariaLabel", "lang", "tabindex", "overwriteUrl", "overwritePath"], outputs: ["fireEvent"] }, { type: i3.TcmPictureComponent, selector: "tcm-picture", inputs: ["lazy", "data", "settings", "overrideImage", "overrideAltText", "overrideTitle", "overrideWidth", "backgroundPicture"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavHeaderLogoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'upr-nav-header-logo', template: "<ng-container *ngIf=\"data\">\r\n\t<tcm-anchor\r\n\t\t[overwriteUrl]=\"headerLogoURL\"\r\n\t\t[transclude]=\"true\"\r\n\t\t[anchorClass]=\"'header-logo'\"\r\n\t>\r\n\t\t<tcm-picture\r\n\t\t\t[overrideImage]=\"data?.Component?.Multimedia?.Url\"\r\n\t\t\t[overrideAltText]=\"(data?.Component?.MetadataFields?.alt?.Values)[0]\"\r\n\t\t\t[lazy]=\"false\"\r\n\t\t>\r\n\t\t</tcm-picture>\r\n\t</tcm-anchor>\r\n</ng-container>\r\n", styles: [""] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['WebContentUrl']
                }] }, { type: i1.LocaleService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class NavHeaderLogoModule {
}
NavHeaderLogoModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavHeaderLogoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NavHeaderLogoModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavHeaderLogoModule, declarations: [NavHeaderLogoComponent], imports: [CommonModule,
        TcmAnchorModule,
        LazyLoadModule,
        TcmPictureModule,
        A11yModule], exports: [NavHeaderLogoComponent] });
NavHeaderLogoModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavHeaderLogoModule, providers: [LocaleService], imports: [[
            CommonModule,
            TcmAnchorModule,
            LazyLoadModule,
            TcmPictureModule,
            A11yModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavHeaderLogoModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TcmAnchorModule,
                        LazyLoadModule,
                        TcmPictureModule,
                        A11yModule
                    ],
                    providers: [LocaleService],
                    declarations: [NavHeaderLogoComponent],
                    exports: [NavHeaderLogoComponent]
                }]
        }] });

export { NavHeaderLogoComponent, NavHeaderLogoModule };
